module.exports = __webpack_public_path__ + "static/media/yellowhead-1.3f8a6f75.jpg";